import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { IFooterLink } from 'src/app/models/footer-link.model';
import { IFooterLogo } from 'src/app/models/footer-logo.model';
import { SitePageService } from 'src/app/services/site-page.service';

@Component({
  selector: 'app-footer',
  imports: [ CommonModule, RouterModule ],
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  private sitePageService = inject(SitePageService);

  public footerLinks : Observable<IFooterLink[]>  = this.sitePageService.getFooterLinks();
  public institutionalLogos : Observable<IFooterLogo[]>  = this.sitePageService.getInstitutionalLogos();
  public partnersLogos : Observable<IFooterLogo[]>  = this.sitePageService.getPartnersLogos();
}
